import { render, staticRenderFns } from "./CadastrarEditarSetorDialog.vue?vue&type=template&id=25008dca"
import script from "./CadastrarEditarSetorDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarSetorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports